import {IncomingHttpHeaders} from "http"

const getRealmFromHeaders = (headers: IncomingHttpHeaders) => `${headers["x-next-realm"]}`

export default getRealmFromHeaders
